window.addEventListener("hoContentLoaded", () => {
	Vue.component('anchor-nav', {
		mixins: [mixinViewport],

		data: () => ({
		}),

		methods: {
			select(id,marginAdd = 0,marginAddMobile= 0)
			{
				console.log("select:",id,marginAdd,marginAddMobile);

				let m = 0;
				if(window.innerWidth < 768)
					m = marginAddMobile;
				else
					m = marginAdd;

				window.providerScroll.scrollTo(document.querySelector('#'+id),m);
			},
		},

		mounted () {}
	});
});
